import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { ITableLargeColumnConfig } from 'projects/common/src/app/interfaces/table/table-large-column-config';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { IShift } from 'src/app/modules/core/interfaces';
import { ChimneyHandlerService } from 'src/app/modules/dashboard/services/chimney/chimney-handler.service';

@Component({
  selector: 'app-production-by-chimney-modal',
  templateUrl: './production-by-chimney-modal.component.html',
  styleUrls: ['./production-by-chimney-modal.component.scss']
})
export class ProductionByChimneyModalComponent implements OnInit {
  @Input() public shift: IShift;
  @Input() public date: string;
  @Input() public zoneId: string;
  @Input() public companyId: string;
  @Input() public chimneyId: string;
  @Input() public chimneyName: string;


  public tableConfig: ITableConfig;
  public resultData: any;


  constructor(
    public activeModal: NgbActiveModal,
    private tableConfigService: TableConfigService,
    private chimneyService: ChimneyHandlerService,
    private languageService: LanguageService) { }

  /**
   * Init component
   */
  public ngOnInit(): void {
    this.getDataChimeney();
  }

  /**
   * get data of Chimney
   */
  public getDataChimeney(): void {
    const params = {
      zoneId: this.zoneId,
      inputDate: this.date,
      shiftId: this.shift.shiftId,
      companyId: this.companyId
    };
    this.chimneyService.getModalChimney(params)
      .then(resultData => {
        if (resultData) {
          this.setTableConfig(resultData);
        }
      });
  }


  /**
   * Set table configuration
   * @param tableData
   */
  public setTableConfig(tableData: any[]): void {
    const excludeColumns = ['startedAt'];

    const customLargeColumns: ITableLargeColumnConfig[] = [
      { field: 'finishedAt', isLargeColumn: true, flexGrow: 1.5 }
    ];

    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns,
      replaceColumnName: [
        { prevName: 'startZone', newName: 'extraction' },
        { prevName: 'endZone', newName: 'dump' },
        { prevName: 'finishedAt', newName: 'finishtime'}],
      customLargeColumns
    };

    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns,
      dateConfig: [
        { field: 'startedAt', format: 'date-time' },
        { field: 'finishedAt', format: 'date-time' }],
      customLargeColumns
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    this.tableConfig = { header, dataset };

  }
}
